import React from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";

const DOT = {
  Draft: "bg-slate-400",
  Active: "bg-emerald-500",
  Completed: "bg-blue-500",
  Delivered: "bg-violet-500",
};

const fmt = (ts) => {
  if (!ts) return "—";
  const d = new Date(ts);
  return isNaN(d) ? "—" : d.toLocaleString("en-IN", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
};

export default function JobTimeline({ jobId }) {
  const { data, isLoading } = useQuery({
    queryKey: ["job-timeline", jobId],
    queryFn: async () => (await api.get(`/jobs/${jobId}/timeline`)).data,
  });

  if (isLoading) return <div className="p-6 text-sm text-slate-400">Loading timeline...</div>;
  const events = data || [];
  if (!events.length) return <div className="p-6 text-sm text-slate-400">No status history yet.</div>;

  return (
    <ol className="p-5 space-y-0" data-testid="job-timeline">
      {events.map((e, i) => (
        <li key={i} className="relative flex gap-4 pb-6 last:pb-0" data-testid={`timeline-item-${i}`}>
          {i < events.length - 1 && <span className="absolute left-[7px] top-4 bottom-0 w-px bg-slate-200" />}
          <span className={`mt-1.5 h-[15px] w-[15px] rounded-full shrink-0 ring-4 ring-white ${DOT[e.status] || "bg-slate-300"}`} />
          <div className="min-w-0">
            <div className="font-semibold text-slate-900 text-sm">
              {e.status || "Unknown"}
              {e.from_status && <span className="font-normal text-slate-400"> · from {e.from_status}</span>}
            </div>
            <div className="text-xs text-slate-500 mt-0.5">{fmt(e.timestamp)} · by {e.user_name}</div>
          </div>
        </li>
      ))}
    </ol>
  );
}
